import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../context";
import AOS from "aos";
import "aos/dist/aos.css";

const getLocalStorage = () => {
  let cocktails = localStorage.getItem("cocktails");
  if (cocktails) {
    return (cocktails = JSON.parse(localStorage.getItem("cocktails")));
  } else {
    return [];
  }
};

const Cocktail = ({ image, name, id, info, glass, favorite }) => {
  const { tempCocktails, setTempCocktails, cocktails, setCocktails } =
    useGlobalContext();

  const heartClicked = () => {
    const newCocktails = cocktails.map((item) => {
      if (item.id === id) {
        item.favorite = !item.favorite;
      }
      return item;
    });
    localStorage.setItem("cocktails", JSON.stringify(newCocktails));
    const oldCocktails = getLocalStorage();

    const favoriteCocktails = oldCocktails.filter((item) => {
      if (item.favorite === true) {
        return item;
      }
    });
    localStorage.setItem("favorites", JSON.stringify(favoriteCocktails));

    setCocktails(newCocktails);
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="cocktail" data-aos="fade-up">
      <Link to={`/cocktails/${id}`} className="link">
        <div className="cocktail-info">
          <img src={image} alt={name} />
          <div className="info">
            <h3>{name}</h3>
            <h4>{glass}</h4>
            <p>{info}</p>
          </div>
        </div>
      </Link>
      <i
        onClick={heartClicked}
        class={
          favorite ? "fa-solid fa-heart active-heart" : "fa-solid fa-heart"
        }
      ></i>
    </div>
  );
};

export default Cocktail;
